'use strict';
var InteractiveTypes = require('./InteractiveTypes');
InteractiveTypes = InteractiveTypes.InteractiveTypes;
var parserHelper = require('./InteractiveParse.js');
var pageHelper = require('../helper/pageHelper.js');
var comHelper = require('../helper/componentHelper.js');
var appTypes = require('../types/appTypes');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var interactiveHelper = require('./InteractiveHelper');
var popupHelper = require('./PopupHelper');

/**
 * 组件运行状态管理
 * @type {clear: InteractiveRuningComList.clear, add: InteractiveRuningComList.add, remove: InteractiveRuningComList.remove, isRuning: InteractiveRuningComList.isRuning}}
 */
var InteractiveRuningComList = {
  /**
   * 清空原来的数据
   */
  clear: function () {
    this.box = {};
  },
  /**
   * 添加一个正在执行动画的组件
   * @param comp
   */
  add: function (comp) {
    if (!this.box) {
      this.clear();
    }
    if (comp)
      this.box[comp.controlID] = comp;
  },
  /**
   * 完成动画时，移除该组件数据
   * @param controlID
   */
  remove: function (controlID) {
    if (this.box)
      delete this.box[controlID];
  },

  /**
   * 指定ID的组件是否正在执行动画交互
   * @param controlID
   * @returns {boolean}
   */
  isRuning: function (controlID) {
    if (this.box)
      return !_.isUndefined(this.box[controlID]);
    return false;
  }
};

function clone(source) {
  if (source) {
    return JSON.parse(JSON.stringify(source));
  }
  return null;
}


function InteractiveTarget(page, target, onFinish) {
  //所有需要执行的动画总数
  var animateCount;
  //已完成的动画总数
  var finishCount;

  var dom;

  var targetComp = page.findComByID(target.ID);

  var isTerminate = false;

  this.targetID = target.ID;

  function init() {
    finishCount = 0;
    animateCount = 0;
  }

  function onAnimateStart(animate) {
    if (animate) {
      if (animate.props) {
        //执行显示交互动画之前，需要先将子组件可见状态改为可见
        if(animate.props.toVisible) {
          interactiveHelper.updateChildDomVisible(targetComp, true);
        }
      }
    }
  }

  function onAnimateComplete() {
    finishCount++;
    if (finishCount >= animateCount) {
      if (onFinish) {
        InteractiveRuningComList.remove(target.ID);
        onFinish(target);
      }
    }
  }

  function onAnimateDone(animate) {
    if (animate) {
      if (animate.props) {
        if (animate.props.afterCSS) {
          dom.css(animate.props.afterCSS);
        }
        if (animate.props.isResize) {
          dom.children('.LinkArea').trigger(appTypes.CUSTOM_EVENT.ON_RESIZE);
        }
        //执行隐藏交互动画之后，需要将子组件可见状态改为不可见
        if(animate.props.toVisible !== undefined && !animate.props.toVisible) {
          interactiveHelper.updateChildDomVisible(targetComp, false);
          interactiveHelper.doUpdateChildVisible(targetComp, false);
        }
      }
    }
  }

  function onProgress(animate) {
    if (dom) {
      if (animate.props.isResize) {
        dom.find('canvas').last().trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
        dom.children().trigger(appTypes.CUSTOM_EVENT.ON_RESIZE);

      }
    }
  }

  function doOpenPopup(dom, popupComp, content, background, callOpened) {
    var isPopup = popupComp.popup;
    var command = popupComp.popupCommand;
    var isToPopup = isPopup && !_.isUndefined(command.contentCommand);
    var baseOption = command.option;
    var comp = page.findComByID(popupComp.controlID);
    var option;
    var fun = function () {
      
      if (isTerminate) {
        doTerminate();
        return;
      }
      //dom.css({visibility: 'visible',display:'block'});
      if (command.contentCommand) {
        option = command.contentCommand.option;
      } else if (command.backgroundCommand) {
        option = command.backgroundCommand.option;
      }
      if (!option) {
        option = {};
      }
      option.complete = function () {
        onAnimateComplete();
        if (callOpened) {
          //callOpened();
        }
      };
      if (isPopup && command.contentCommand) {
        dom.css({visibility: 'visible', display: 'block'});
        //todo:mxj 这一段考虑放到弹出管理类中，在这里只管理分发事件
        if (command.backgroundCommand) {
          animateCount++;
        }
        if (command.contentCommand) {
          animateCount++;
        }
        if (command.backgroundCommand) {
          background.animate(command.backgroundCommand.params, option);
        } else if (command.backgroundCSS) {
          background.css(command.backgroundCSS)
        }
        if (command.contentCommand) {
          if (command.contentCommand.previourCSS) {
            content.css(command.contentCommand.previourCSS);
          }
          content.animate(command.contentCommand.params, option);
        } else {
          content.css({opacity: 1});
        }
      } else {
        // todo: mengxiaojiang 2016-7-14
        // 这一段实际上目前并没有执行。需要考虑弹出的机制
        // 对于交互时写入的popup属性，
        // 在弹出之前置为ture，使组件先加载到节点中，然后执行动画
        // 在关闭时，先执行必要的动画之后置再为false，使用组件从节点中移除
        dom.trigger(popupHelper.CLOSE_POPUP_EVENT, {
          callback: function (comID) {
            var c = page.findComByID(comID);
            if (c) {
              c.popup = false;
              delete c.popupCommand;
              delete c.open;
              pageHelper.updatePageComData(page.state.page, c);
              page.refresh(page.state.page);
              InteractiveRuningComList.remove(comID)
            }
            onAnimateComplete();
          },
          controlID: popupComp.controlID
        });
        return;
      }
      if (comp) {
        delete comp.popupCommand;
        delete comp.open;
        pageHelper.updatePageComData(page.state.page, comp);
        page.refresh(page.state.page);
      }
    };

    var bindToFront = function () {
      var popupPage = $(ReactDOM.findDOMNode(page)).find('.page-popup');
      var container = popupPage.children().eq(0);
      if (!container || !container[0]) { // FIXME: 2016-11-22 杨思柏修改，container[0] 可能为 undefined 不知道什么原因
        return
      }
      var count = container[0].childElementCount;
      var i;
      var maxZIndex = 0;
      for (i = 0; i < count; i++) {
        maxZIndex = Math.max(maxZIndex, parseInt(container[0].children[i].style.zIndex, 10));
      }
      dom.css({'z-index': maxZIndex + 1});
    };
    if (isToPopup)
      dom.css({visibility: 'hidden', display: 'none'});
    bindToFront();
    //延时弹出
    if (baseOption.delay) {
      setTimeout(fun, baseOption.delay);
    } else {
      //立即弹出
      fun();
    }
  }

  function doClosePopup(dom, popupComp, content, background) {
    var isPopup = popupComp.popup;
    var command = popupComp.popupCommand;
    if(!command) {
      return;
    }
    var isToPopup = isPopup && !_.isUndefined(command.contentCommand);
    var baseOption = command.option;
    var comp = page.findComByID(popupComp.controlID);
    var fun = function () {
      var duration = 150;           //Allen: 此处间隔时间之后需重新考虑
      content.animate({opacity: 0}, {
        queue: false, duration: duration, complete: function () {
          if(comp) {
            comp.isPopupClosing = false;
            comp.isNeedAnimate = false;
            pageHelper.updatePageComData(page.state.page, comp);
            page.refresh(page.state.page);
          }
        }
      });
      background.animate({opacity: 0}, {queue: false, duration: duration});
    };

    if (!isToPopup)
      dom.css({visibility: 'visible', display: 'block'});
    //延时弹出
    if (baseOption.delay) {
      setTimeout(fun, baseOption.delay);
    } else {
      //立即弹出
      fun();
    }
  }

  function doStack(targetComp, cmd) {
    var dom = $('#' + targetComp.controlID);
    dom.trigger('onSwitch', [targetComp.controlID, cmd.params.currentIndex, cmd.params.nextIndex, onAnimateComplete]);
  }

  function doScroll(targetComp, cmd) {
    var _dom = $('#' + targetComp.controlID).children();
    _dom.trigger('onScrollTo', [targetComp.controlID, cmd.params, onAnimateComplete]);
  }

  function doTerminate() {
    finishCount = animateCount;
    onAnimateComplete();
  }

  /**
   * 构建一个执行指定命令的函数对象
   * @param targetComp
   * @param dom
   * @param cmd
   * @returns {fun}
   */
  function createCommandFun(targetComp, dom, cmd) {
    var fun = function () {
      var _dom = dom;
      var complete;
      InteractiveRuningComList.add(targetComp);
      if (cmd.isScrollFire) {
        doScroll(targetComp, cmd);
        return;
      }
      if (cmd.isStackFire) {
        doStack(targetComp, cmd);
        return;
      }
      complete = cmd.option.complete;
      if (cmd.previourCSS) {
        _dom.css(cmd.previourCSS);
      }
      if (cmd.option.delay) {
        _dom.delay(cmd.option.delay);
      }
      if (cmd.option.autoReverse) {
        delete cmd.option.complete;
      }
      _dom.animate(cmd.params, cmd.option);
      cmd.option.complete = complete;
      if (cmd.option.autoReverse) {
        _dom.delay(cmd.option.duration).animate(cmd.recovery, cmd.option);
        if (cmd.recoveryCSS) {
          _dom.css(cmd.recoveryCSS);
        }
      }
    };
    return fun;
  }

  function doPropsChangeCommand(targetComp, cmd) {
    var fn = function () {
      var k;
      var com;
      var pageData;
      var callback;
      var f;
      var tid;
      if (isTerminate) {
        if (tid) {
          clearTimeout(tid);
        }
        doTerminate();
      }
      com = page.findComByID(targetComp.controlID);
      pageData = page.state.page;
      callback = cmd.option.complete;
      f = function () {
        if (com) {
          InteractiveRuningComList.add(com);
          for (k in cmd.params) {
            com[k] = cmd.params[k];
            com[interactiveHelper.CurrentPropsMap[k]] = cmd.params[k];
          }
          pageHelper.updatePageComData(pageData, com);
          page.refresh(pageData);
      }
        if (callback) {
          callback();
        }
      };

      if (cmd.option && cmd.option.delay) {
        tid = setTimeout(f, cmd.option.delay);
      } else {
        f();
      }
    };
    return fn;
  }

  function registerAnimateEvent(option) {
    option.complete = onAnimateComplete;
    option.done = onAnimateDone;
    option.progress = onProgress;
  }

  //同步执行所有命令
  function doParallelStartCommand() {
    var cmd;
    var i;
    var noDelays;
    var delays;
    var commands = target.commands;
    var fns = [];
    var commandFunc;
    var params;
    //1、遍历所有命令，把所有不延时的动画提前
    //2、执行所有动画
    noDelays = [];
    delays = [];
    //对不延时的动画，是否需要合并动画属性，如果合并，应考虑改变属性的交互命令的逻辑流程
    for (i = 0; i < commands.length; i++) {
      cmd = clone(commands[i]);
      if (cmd.isChecked) {
        if (!cmd.option.delay) {
          noDelays.push(cmd);
        } else {
          delays.push(cmd);
        }
        animateCount++;
        if (cmd.option.autoReverse) {
          //animateCount++;
        }
      }
    }

    i = 0;
    for (i; i < noDelays.length; i++) {
      cmd = noDelays[i];
      cmd.option.queue = false;
      cmd.option.start = onAnimateStart;
      cmd.option.complete = onAnimateComplete;
      cmd.option.done = onAnimateDone;
      cmd.option.progress = onProgress;
      if (cmd.isPropsFire) {
        commandFunc = doPropsChangeCommand(targetComp, cmd);
      } else {
        commandFunc = createCommandFun(targetComp, dom, cmd);
      }
      if (target.isRecovery && target.shouldRecovery) {
        fns.unshift(commandFunc);//自动还原时
      } else {
        fns.push(commandFunc);
      }
    }
    i = 0;
    for (i; i < fns.length; i++) {
      fns[i]();
    }



    i = 0;
    fns = [];
    for (i; i < delays.length; i++) {
      cmd = delays[i];
      if (cmd.isPopupFire) {
        continue;
      }
      cmd.option.queue = true;
      cmd.option.start = onAnimateStart;
      cmd.option.complete = onAnimateComplete;
      cmd.option.done = onAnimateDone;
      cmd.option.progress = onProgress;
      if (cmd.isPropsFire) {
        commandFunc = doPropsChangeCommand(targetComp, cmd);
      } else {
        commandFunc = createCommandFun(targetComp, dom, cmd);
      }
      if (target.isRecovery && target.shouldRecovery) {
        fns.unshift(commandFunc);//自动还原时
      } else {
        fns.push(commandFunc);
      }
    }

    i = 0;
    for (i; i < fns.length; i++) {
      if (!isTerminate)
        fns[i]();
    }
  }

  //顺序执行所有命令
  function doSequenceStartCommand() {
    var option;
    var cmd;
    var i;
    var commands = target.commands;
    var fns = [];
    var commandFunc;

    var callback = function () {
      if (!isTerminate)
        dom.dequeue('cmds');
    };

    //统计需要执行的动画数量
    for (i = 0; i < commands.length; i++) {
      cmd = commands[i];
      if (cmd.isChecked) {
        animateCount++;
        if (cmd.option && cmd.option.autoReverse) {
          //animateCount++;
        }
      }
    }

    function onComplete() {
      onAnimateComplete();
      callback();
    }

    for (i = 0; i < commands.length; i++) {
      cmd = clone(commands[i]);

      if (cmd.isChecked) {
        if (cmd.isPopupFire) {
          continue;
        }
        option = cmd.option;
        option.queue = true;
        option.start = onAnimateStart;
        option.complete = onComplete;
        option.done = onAnimateDone;
        option.progress = onProgress;
        if (cmd.isPropsFire) {
          commandFunc = doPropsChangeCommand(targetComp, cmd);
        } else {
          commandFunc = createCommandFun(targetComp, dom, cmd);
        }
        if (target.isRecovery && target.shouldRecovery) {
          fns.unshift(commandFunc);//自动还原时
        } else {
          fns.push(commandFunc);
        }
      }
    }

    if (fns.length) {
      dom.queue('cmds', fns);
      callback();
    }
  }

  this.terminate = function () {
    if (dom) {
      dom.stop('cmds', true, true);
    }
    isTerminate = true;
  };

  //启动目标上的交互
  this.start = function () {
    var pageData;
    init();
    if (!isTerminate && target.isChecked) {
      dom = $('#' + target.ID);
      //弹出组件另行处理,目前弹出组件上本身不会同时存在多个命令运行。故可以不考虑其是否同时工作
      if (pageHelper.IsInvisualInteractiveCom(targetComp.controlTypeID)) {
        if (targetComp) {
          if (!targetComp.popup) {
            InteractiveRuningComList.remove(targetComp.controlID);
            if(targetComp.isNeedAnimate) {
              targetComp.isPopupClosing = true;     //Allen: 正在关闭弹出面板标志
            }
          } else {
            InteractiveRuningComList.add(targetComp);
          }
          pageData = page.state.page;
          targetComp.popupCommand = target.commands[0];
          targetComp.open = doOpenPopup;
          targetComp.closePopup = doClosePopup;
          pageHelper.updatePageComData(pageData, targetComp);
          page.refresh(pageData);
        } else {
          onAnimateComplete();
        }
      } else {
        if (target.isParallel) {
          doParallelStartCommand();
        } else {
          doSequenceStartCommand();
        }
      }
    } else {
      onAnimateComplete();
    }
  };
}

/**
 * 交互驱动类
 * @constructor
 */
function InteractiveWorker(page, source, onFinish) {
  var _targets;
  var _behaviour;
  var isParallel;
  var targetCount;
  var finishCount;
  var runList;

  var isTerminate = false;

  var interval = parseInt(source.interval,10) || 0;


  function init() {
    _targets = [];
    runList = [];
    targetCount = 0;
    finishCount = 0;
  }

  function builderAllTargets() {
    var i;
    var target;
    for (i = 0; i < _behaviour.target.length; i++) {
      target = _behaviour.target[i];
      if (target.isChecked) {
        targetCount++;
        _targets.push(new InteractiveTarget(page, target, onAnimateFinish));
      }
    }
  }

  function onAnimateFinish(target) {
    var targetCom;
    finishCount++;

    if (isTerminate) {
      if (finishCount === targetCount) {
        if (onFinish) {
          onFinish(source);
        }
      }
      return;
    }
    if (target) {
      runList.push(target.ID);
      targetCom = page.findComByID(target.ID);
      if (targetCom) {
        pageHelper.updatePageComData(page.state.page, targetCom);
      } else {
        InteractiveRuningComList.remove(target.ID);
      }
    }
    if (finishCount >= targetCount) {
      switchShouldRecovery();
      if (onFinish) {
        onFinish(source);
      }
    } else {
      if (!isParallel && !isTerminate) {
        //_targets[finishCount].start();
        targetStart(_targets[finishCount]);
      }
    }
  }

  function switchShouldRecovery() {
    var i;
    var target;
    for (i = 0; i < _behaviour.target.length; i++) {
      target = _behaviour.target[i];
      if (target.isChecked) {
        if (target.isRecovery) {
          target.shouldRecovery = !target.shouldRecovery;
        }
      }
    }
  }

  function targetStart(target) {
    target.start();
  }

  function doStart() {
    var i;
    if (_targets.length) {
      if (isParallel) {
        for (i = 0; i < _targets.length; i++) {
          if (!isTerminate) {
            //_targets[i].start();
            targetStart(_targets[i]);
          }
        }
      } else {
        if (!isTerminate) {
          //_targets[finishCount].start();
          targetStart(_targets[finishCount]);
        }
      }
    } else {
      onAnimateFinish();
    }
  }

  this.terminateAll = function () {
    var i;
    var targetWorker;
    isTerminate = true;
    if(_targets) {
      for (i = 0; i < _targets.length; i++) {
        targetWorker = _targets[i];
        if (runList.indexOf(targetWorker.ID) === -1)
          targetWorker.terminate();
      }
    }
    init();
  };

  function _start(){
    init();
    builderAllTargets();
    doStart();
  }

  this.start = function (behaviour) {
    _behaviour = behaviour;
    isParallel = _behaviour.isParallel;
    init();
    builderAllTargets();
    doStart();
    //setTimeout(_start,interval);
  };
}

/**
 @Author : mengxiaojiang
 @CreateDate : 2016-5-3
 @Descript : 交互管理类，每次启动时，先创建一个InteractiveWorker,然后启动这个worker
 */
function InteractiveManager() {
  var _source;
  var _eventType;
  var _entryIndex;
  var _state = InteractiveTypes.InteractiveWorkerStateType.NONE;
  var _itemFinishCount = 0;
  var currentPage = null;
  var _behaviour = null;

  var worker;

  /**
   *
   */
  function doInit() {
    _state = InteractiveTypes.InteractiveWorkerStateType.NONE;
    _itemFinishCount = 0;
  }

  this.getInteractiveState = function() {
    return InteractiveRuningComList;
  };

  /**
   * 判断源及源的目标是否正在工作中
   * @param sourceCom
   * @returns {boolean}
   */
  this.isWorking = function(sourceCom) {
    var targetID;
    var targetComp;
    var i = 0;
    if (InteractiveRuningComList.isRuning(sourceCom.controlID)) {
      return true;
    }
    if (_behaviour && _behaviour.target) {
      for (i; i < _behaviour.target.length; i++) {
        targetID = _behaviour.target[i].targetID;
        targetComp = currentPage.findComByID(targetID);
        if (pageHelper.IsInvisualInteractiveCom(targetComp.controlTypeID)) {
          if (!targetComp.popup) {
            InteractiveRuningComList.remove(targetID);
            continue;
          }
        }
        if (InteractiveRuningComList.isRuning(targetID)) {
          return true;
        }
      }
    }
  };

  /**
   * 事件源所属的所有交互都完成后的回调
   * @param source
   */
  function onWorkerItemFinish(source) {
    if (_state != InteractiveTypes.InteractiveWorkerStateType.NONE) {
      doInit();
      if (source) {
        InteractiveRuningComList.remove(source.controlID)
      }
      currentPage.refresh(currentPage.state.page);
    }
  }

  /**
   * 查找需要执行的行为
   * @returns {*}
   */
  function findBehaviour() {
    var event = comHelper.findEventByType(_source, _entryIndex, _eventType);
    if (event) {
      return event.behaviour[0];
    }
    return null;
  }

  /**
   * 解析事件源上的交互数据为可识别的数据格式，并记录到事件源组件上
   * @returns {{}|*}
   */
  function parseSourceInteractiveData() {
    var data;
    var entry;
    var behaviour;
    var target;
    var _target;
    var targetCom;
    var command;
    var commandCount;
    var _cmd;
    var event;
    var i;
    var j;
    var targetIndex;
    //var ignoreSourceRuning = false;
    var pageData = currentPage.state.page;
    data = _source._interactiveData;
    if (!data) {
      data = {};
    }
    if (!data.entries) {
      data.entries = {};
    }
    if (!data.entries[_entryIndex]) {
      entry = data.entries[_entryIndex] = {};
    } else {
      entry = data.entries[_entryIndex];
    }
    event = entry[_eventType];
    if (!event) {
      event = entry[_eventType] = {};
    }
    event.isChecked = true;//这里的选中状态，始终是为true的
    behaviour = event.behaviour ? event.behaviour[0] : {};
    behaviour.isChecked = _behaviour.isChecked;
    behaviour.isLoop = _behaviour.isLoop;
    behaviour.isWait = _behaviour.isWait;
    behaviour.isParallel = _behaviour.execMode === InteractiveTypes.ExecuteModeType.PARALLEL;
    if (!event.behaviour) {
      event.behaviour = [behaviour];
    }
    if (!behaviour.target) {
      behaviour.target = [];
    }
    targetIndex = 0;
    for (i = 0; i < _behaviour.target.length; i++) {
      _target = _behaviour.target[i];
      targetCom = clone(currentPage.findComByID(_target.targetID));
      if (targetCom) {
        if (_target.isChecked) {//未选中的目标，不进行交互解析
          if (behaviour.target.length > targetIndex) {
            target = behaviour.target[targetIndex];     //Allen:原来的代码直接使用i坐下标，有bug，此处未选中targetIndex不自增
          } else {
            target = {shouldRecovery: false};
            behaviour.target.push(target);
          }
          targetIndex++;
          target.isChecked = _target.isChecked;
          target.isRecovery = _target.isAutoRecovery;
          target.isLoop = _target.isLoop;
          target.isWait = _target.isWait;
          target.isParallel = _target.execMode === InteractiveTypes.ExecuteModeType.PARALLEL;
          target.ID = _target.targetID;

          if (!target.commands) {
            target.commands = [];
          }
          //对内容面板的命令解析，只认第一个
          commandCount = _target.command.length;
          if (commandCount && targetCom.controlTypeID === 'ContentPanel') {
            commandCount = 1;
          }
          for (j = 0; j < commandCount; j++) {
            _cmd = _target.command[j];
            if (target.commands.length > j) {
              command = target.commands[j];
            } else {
              command = {};
              target.commands.push(command);
            }
            command.isChecked = _cmd.isChecked;

            command.params = {};

            //todo mxj 弹出命令由于有主动关闭的特点，其在主动关闭时，未通过命令执行关闭，故在解析命令前，如果弹出组件为关闭状态，则其shouldRecovery的值应默认为false。
            if (pageHelper.IsInvisualInteractiveCom(targetCom.controlTypeID)) {
              if (!targetCom.popup) {
                target.shouldRecovery = false;
              }
            }
            if (command.isChecked) {//未选中的交互命令，不进行参数解析
              if (target.isRecovery && target.shouldRecovery) {
                //自动还原
                //--------------------------------------------------
                // matt 2017-10-18
                //以之前动画参数作为还原时动画前的样式状态
                command.previourCSS = clone(command.params);
                //--------------------------------------------------
                command.params = command.recovery;

                //todo mxj 如果是弹出组件的自动还原，不可直接修改组件数据的popup为false，根据前期针对弹出命令的执行逻辑，直接在这里清除命令中的contentCommand数据。
                if (pageHelper.IsInvisualInteractiveCom(targetCom.controlTypeID)) {
                  delete command.contentCommand;
                }
              } else {
                if (command.isChecked) {
                  parserHelper.parser(currentPage, command, _cmd, targetCom, _source);
                }
              }
              if (pageHelper.IsInvisualInteractiveCom(targetCom.controlTypeID)) {
                targetCom.popupCommand = command;
              }
              pageHelper.updatePageComData(pageData, targetCom);
            }
          }
          if (target.isRecovery && target.shouldRecovery) {
            j = target.commands.length - 1;
            for (j; j >= 0; j--) {
              recoveryComProps(targetCom, target.commands[j]);
            }
          }
        }
      }
    }
    //这里的Source有可能是同时作为目标的。
    //这种情况下，如果直接把Source克隆后的数据更新到PageData中后，会有可能覆盖掉针对它上面设置的交互命令数据，从而导致针对它的命令不会被执行

    pageHelper.updateComData(pageData, _source.controlID, '_interactiveData', data);
    currentPage.refresh(pageData);
    return behaviour;
  }

  function recoveryComProps(comp, cmd) {
    var k;
    var propsName;
    var recoveryProps = cmd.recovery;
    for (k in recoveryProps) {
      propsName = interactiveHelper.CurrentPropsMap[k];
      if (propsName) {
        if(cmd.isPropsFire){
          delete comp[propsName];
        }else {
          comp[propsName] = recoveryProps[k];
        }
      }
    }
  }

  this.reset = function () {
    InteractiveRuningComList.clear();
    if (worker) {
      worker.terminateAll();
    }
  };
  /***
   * 启动一个交互
   * @param page 当前页面
   * @param sourceCom 事件源
   * @param eventType 触发事件
   * @param entryIndex 入口索引
   */
  this.start = function (page, sourceCom, eventType, entryIndex) {
    var behaviourRec;
    if (!currentPage || currentPage.props.page.ID !== page.props.page.ID) {
      InteractiveRuningComList.clear();
    }
    currentPage = page;
    _source = clone(page.findComByID(sourceCom.controlID));
    _eventType = eventType;
    _entryIndex = entryIndex;
    _behaviour = findBehaviour();
    if (!_behaviour) {
      return;
    }
    if (this.isWorking(sourceCom))
      return;

    behaviourRec = parseSourceInteractiveData();
    doInit();
    _state = InteractiveTypes.InteractiveWorkerStateType.RUNNING;
    worker = new InteractiveWorker(page, _source, onWorkerItemFinish);
    worker.start(behaviourRec);
  };
}


function D(){
  var manager = null;
  this.reset = function(){
    if(manager)
      manager.reset();
  };

  this.start = function(page,sourceCom,eventType,entryIndex){
    manager = new InteractiveManager();
    manager.startNew(page,sourceCom,eventType,entryIndex);
  };

  this.getInteractiveState = function() {
    return InteractiveRuningComList;
  };
}

var Instance = new InteractiveManager();

module.exports = Instance;


// WEBPACK FOOTER //
// ./src/interactive/InteractiveManager.js